/**
 * Reads a VITE_ env var at runtime from window.__env__ (injected by docker-entrypoint.sh
 * when running in a pod), falling back to import.meta.env for local dev (where .env is used).
 */
const runtimeEnv = (typeof window !== 'undefined' && (window as any).__env__) || {}

export const env = (key: string): string =>
  runtimeEnv[key] ?? import.meta.env[key] ?? ''
